export const DEFAULT_PLACEHOLDER = 'Search for people and more...';
export const SMALLER_SCREEN_PLACEHOLDER = 'Search';
export const SEARCH_SKELETON_LENGTH = 3;
